import Vue from 'vue'
import App from './App'
import router from './router/router'
import store from './store'
import Vuetify from 'vuetify'
import VueCookie from 'vue-cookie'
import 'vuetify/dist/vuetify.min.css'
import './assets/stylesheets/reset.css'
import './assets/stylesheets/typography.css'
import './assets/stylesheets/style.css'
import './assets/stylesheets/main.css'
import NavBar from './components/NavBar'
import Footer from './components/Footer'
import i18n from './assets/js/lang/lang.js'
import appMixins from './mixins/appMixins'
import notifications from 'vue-notification'
import VeeValidate from 'vee-validate'
import ToggleButton from 'vue-js-toggle-button'
import moment from 'moment'
import currency from 'v-currency-field'
import 'v-currency-field/dist/index.css'
import usStates from './usStates'

moment.suppressDeprecationWarnings = true

Vue.use(Vuetify)
Vue.use(VueCookie)
Vue.use(notifications)
Vue.use(VeeValidate)
Vue.use(ToggleButton)
Vue.use(currency)

VeeValidate.Validator.extend('valid_us_state', {
  getMessage(field,args) {
    return 'Invalid state'
  },

  validate(value) {
    return usStates.includes(value);
  }
})

VeeValidate.Validator.extend('valid_lender_state', {
  getMessage(field,args) {
    return 'Invalid state for selected lenders'
  },

  validate(value) {
    if (store.getters.getDealerApplication && store.getters.getDealerApplication.lenders) {
      for (var lender of store.getters.getDealerApplication.lenders) {
        if (lender.blacklistStates && lender.blacklistStates.includes(value)) {
          return false;
        }
      }
    }
    return true;
  }
})

VeeValidate.Validator.extend('valid_ssn', {
  getMessage(field, args) {
    return 'Invalid SSN'
  },

  validate(value, args) {
    if (value == '123456789') return false
    return /^(?!000|666)[0-8][0-9]{2}(?!00)[0-9]{2}(?!0000)[0-9]{4}$/.test(
      value
    )
  }
})

//not sure why Vue.use(moment) doesn't work
window.moment = require('moment')

Vue.component('nav-bar', NavBar)
Vue.component('footer-bar', Footer)

Vue.mixin(appMixins)

window.appMixins = appMixins
window.notifications = notifications

export const EventBus = new Vue()

//Default axios url
axios.defaults.baseURL = process.env.ROOT_API
axios.defaults.withCredentials = true

//NAVIGATION AUTHENTICATION
//
//Mechanism for verifying authentication on each page
//
//On the vue-router, before each time the path changes check to see if
//login is required for the page. (loginRequired is a 'meta' attribute associated
//with each path in the router file

//Put the program back into the store on refresh
const putProgramInStore = function() {
  if ((store.getters.getProgram == '' || typeof store.getters.getProgram === 'undefined') && VueCookie.get('program')) {
    //Parse the program String
    var programArray = VueCookie.get('program').split('|')
    var program = { id: '', name: '', domain: '' }

    program.id = programArray[0]
    program.name = programArray[1]
    program.domain = programArray[2]

    store.commit('setProgram', program)
  }
}

//on page refresh, put the cookie app id in the store if we have it
const putAppIdInStore = function() {
  //If we are going to the application, and the store does not have an application ID
  if (store.getters.getApplicationId == '' && VueCookie.get('applicationId')) {
    store.commit('setApplicationId', VueCookie.get('applicationId'))
  }
}

//dealer app status values
export const APP_STATUSES = {
  IN_PROGRESS: 0,
  SUBMITTED: 1,
  SIGNED_OFF: 2,
  UNDERWRITTEN: 3
}

router.beforeEach((to, from, next) => {
  putProgramInStore()

  if (to.name == 'application' || to.name == 'submittedApplication') {
    putAppIdInStore()
  }

  if (to.matched.some(record => record.meta.loginRequired)) {
    if (!store.getters.getAuthenticatedUser) {
      userRefreshFromSession(next)
    } else {
      next()
    }
  } else {
    next()
  }
})

//AXIOS AUTH REQUEST
//
//This mechanism will allow use to intercept each request to the api and attach our
//auth tokens from the store
//Also set the with credentials flag
export let axiosAuthInstance = axios.create()

axiosAuthInstance.interceptors.response.use(
  response => {
    return response
  },
  function(error) {
    if (
      error.response &&
      (error.response.status === 408 || error.response.status === 401)
    ) {
      router.push('/login')
    }

    return Promise.reject(error)
  }
)

const userRefreshFromSession = function(next) {
  axiosAuthInstance
    .get('api/v1/participant/authed')
    .then(response => {
      if (response.data) {
        store.commit('setAuthenticatedUser', response.data)
      }

      next()
    })
    .catch(error => {
      next('/')
    })
}

// Main Vue Component, ROOT of the project, etc
new Vue({
  el: '#app',
  components: {
    App: App
  },
  template: '<App/>',
  router,
  store,
  i18n
})



// WEBPACK FOOTER //
// ./src/main.js